const Note = () => {

    return (<div>일단 여기는 Note</div>);
}

export default Note;